import api from '../api/live-card-articles-api';


export const getArticlesByPlayerId = async ({ callbackUrl }) => {
    const articlesByPlayerId = await fetchData({
        callbackUrl,
    });

    if (articlesByPlayerId.error) {
        return {
            error: articlesByPlayerId.error,
        };
    }
    return articlesByPlayerId;
};

const fetchData = async ({ callbackUrl, params }) => {
    try {
        const response = await api.get(callbackUrl, {
            params,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });

        return response.data;
    } catch (error) {
        return {
            error: {
                isEmpty: false,
                value: error,
                statusCode: error.response ? error.response.status : null
            },
        };
    }
};
